import { ErrorHandler, shouldPassiveAuth } from '@xfinity/maw-fetch';
import { SWAP_ELIGIBILITY } from './apis';
import COTTON_PATH from './apiPaths';

// Custom error handler for maw-fetch client to handle a problem with the swaps eligibility API
export const ApiErrorHandler = () => {
  const mawFetchOnError = ErrorHandler();
  // Can't match as desired if there is a query param ? in the string passed to .match
  const [eligibilityApi] = SWAP_ELIGIBILITY.split('?');

  return ({ request, error, ...rest }) => {
    // Throw the error instead of passing to the standard error handler which would forceAuth
    // if the request URL contains "cotton" in the path bcs we will fall back to Ruby api
    if (request.url.includes(COTTON_PATH)) {
      throw error;
    }
    if (
      request.url.match(eligibilityApi)
      && shouldPassiveAuth(error)
    ) {
      // There is an issue where unrestricted secondaries may get an incorrect SH401.56.18 response
      // from equipment swap eligibility check.
      // Throw the error instead of passing to the standard error handler which would forceAuth.
      throw error;
    }

    // Use standard error handling otherwise
    return mawFetchOnError({ request, error, ...rest });
  };
};

const getErrorsMap = () => [
  {
    id: 'SH400.10.2',
    message: 'This email address is already associated with an Xfinity account',
    field: 'emailAddress',
  },
  {
    id: 'SH400.10.3',
    message: 'This phone number is already associated with an Xfinity account',
    field: 'mobilePhone',
  },
  {
    id: 'SH500.40.01',
    message: 'This username is already taken',
    field: 'userId',
  },
];

export const getErrorFromResponse = (response = {}, user = {}) => {
  const code = (response.data && (response.data.code || response.data.errorCode)) || null;
  const message = response.data && (response.data.clientMessage || response.data.message);
  const error = getErrorsMap(user).find(e => e.id === code || e.id === message) || {};

  return Object.assign({}, response.data, error, {
    message: error.message || message,
    isMapped: !!error.id,
  });
};

export const scrollToInvalid = (errors = {}) => {
  const invalidName = Object.keys(errors).find(key => key !== 'error'); // might need to check for undefined
  if (invalidName) {
    const invalidInput = document.getElementsByName(invalidName)[0];
    window.scrollTo(0, window.pageYOffset
      + (invalidInput.getBoundingClientRect().top - 50));
    invalidInput.focus();
  } else {
    window.scrollTo(0, 0);
  }
};
